import { PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

export type ChatModalContextProps = {
  isOpen: boolean;
  close: () => void;
  open: (el: HTMLButtonElement) => void;
  anchorEl: HTMLButtonElement | null;
};

const ChatModalContext = createContext({} as ChatModalContextProps);

export const ChatModalContextProvider = ({ children }: PropsWithChildren) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const open = useCallback((el: HTMLButtonElement) => {
    setAnchorEl(el);
  }, []);

  const value = {
    open,
    close,
    anchorEl,
    isOpen: !!anchorEl,
  };

  return <ChatModalContext.Provider value={value}>{children}</ChatModalContext.Provider>;
};

export const useChatModalContext = () => useContext(ChatModalContext);
